// extracted by mini-css-extract-plugin
module.exports =  {"modalWidth":"564px","modal":"modal--A74eG","head":"head--hTkNy","action-btn":"action-btn--lfLZg","actionBtn":"action-btn--lfLZg","body":"body--LHoPy"};